import { render, staticRenderFns } from "./SubGroup.vue?vue&type=template&id=37f200a5"
import script from "./SubGroup.vue?vue&type=script&lang=js"
export * from "./SubGroup.vue?vue&type=script&lang=js"
import style0 from "./SubGroup.vue?vue&type=style&index=0&id=37f200a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports